import { createRouter, createWebHashHistory } from 'vue-router';
import { clearToken, getToken, isTokenExpired } from '@/utils/auth';
import LoginView from '@/views/LoginView.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import DashboardView from '@/views/dashboard/DashboardView.vue';
import ProductsView from '@/views/products/ProductsView.vue';
import PromptsView from '@/views/prompts/PromptsView.vue';
import SettingsView from '@/views/settings/SettingsView.vue';
import UsersView from '@/views/users/UsersView.vue';
import VariationTemplatesView from '@/views/variation-templates/VariationTemplatesView.vue';
import EtsyRecordsView from '@/views/etsy-records/EtsyRecordsView.vue';
import EtsyShippingProfilesView from '@/views/etsy-shipping-profiles/EtsyShippingProfilesView.vue';

const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: AppLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: DashboardView
      },
      {
        path: 'products',
        component: ProductsView
      },
      {
        path: 'prompts',
        component: PromptsView
      },
      {
        path: 'variation-templates',
        component: VariationTemplatesView
      },
      {
        path: 'etsy-records',
        component: EtsyRecordsView
      },
      {
        path: 'etsy-shipping-profiles',
        component: EtsyShippingProfilesView
      },
      {
        path: 'settings',
        component: SettingsView
      },
      {
        path: 'users',
        component: UsersView
      }
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (getToken() && !isTokenExpired()) {
      next('/dashboard');
      return;
    }
    next();
    return;
  }
  if (!getToken() || isTokenExpired()) {
    clearToken();
    next('/login');
    return;
  }
  next();
});

export default router;
